export default __webpack_public_path__ + "static/media/hnh5.b99afe6b.png";